import React from 'react'
import { Button, Card, Layout, Typography } from 'antd'
import { Link } from 'react-router-dom'

const { Title, Paragraph, Text } = Typography

/** صفحة تسويقية لتطبيق LeenGo (عربي) — مناسبة لحقل Marketing URL في App Store. */
export default function Marketing() {
    return (
        <Layout style={{ minHeight: '100vh', background: '#f4ede3' }}>
            <Layout.Content style={{ padding: 'clamp(16px, 4vw, 32px)', maxWidth: 840, margin: '0 auto', width: '100%' }}>
                <div dir="rtl" lang="ar" style={{ textAlign: 'right' }}>
                    <div style={{ marginBottom: 20 }}>
                        <Link to="/">
                            <Button type="link" style={{ paddingInline: 0 }}>← العودة إلى الرئيسية</Button>
                        </Link>
                    </div>

                    <Card styles={{ body: { padding: 'clamp(20px, 4vw, 32px)' } }}>
                        <Title level={2} style={{ marginTop: 0 }}>LeenGo — لين غو في جيبك</Title>
                        <Text type="secondary">تطبيق التسوّق والطلبات الرسمي من لين غو</Text>
                        <Paragraph style={{ marginTop: 8 }}>
                            <Text strong>آخر تحديث:</Text> ١ أبريل ٢٠٢٦
                        </Paragraph>

                        <Title level={4}>ما هو LeenGo؟</Title>
                        <Paragraph>
                            <Text strong>LeenGo</Text> هو تطبيق الجوال المصمّم لخدمتك أينما كنت: تتصفّح المتاجر والعروض،
                            تضيف منتجاتك إلى السلّة، وتتابع طلباتك من مكان واحد — بالتكامل مع منصّة{' '}
                            <Text strong>لين غو</Text> وموقع <Text code>leen-go.com</Text> لنفس تجربة الطلب الموثوقة.
                        </Paragraph>

                        <Title level={4}>لماذا التطبيق؟</Title>
                        <ul style={{ paddingInlineStart: 20, marginTop: 0 }}>
                            <li>تسوّق من متاجر متعدّدة وفق منطقة التوصيل التي تختارها.</li>
                            <li>سلّة واضحة، ملخّص للطلب، ومتابعة لحالة الطلب.</li>
                            <li>تسجيل دخول آمن برقم الهاتف ورمز تحقق (OTP).</li>
                            <li>إشعارات لتنبيهك عند الحاجة (حسب إعدادات جهازك وصلاحيات التطبيق).</li>
                            <li>واجهة بالعربية واتجاه مناسب للقراءة من اليمين إلى اليسار.</li>
                        </ul>

                        <Title level={4}>تجربة متصلة</Title>
                        <Paragraph>
                            يكمّل التطبيق تجربة التسوّق عبر الويب: يمكنك الاستفادة من الموقع أو التطبيق حسب ما يناسبك، مع
                            الحفاظ على نفس رؤية لين غو في الخدمة والجودة.
                        </Paragraph>

                        <Title level={4}>التنزيل</Title>
                        <Paragraph>
                            يمكنك تنزيل التطبيق لنظام <Text strong>Android</Text> من متجر Google Play — ابحث عن{' '}
                            <Text strong>LeenGo</Text> أو استخدم الرابط المباشر:
                        </Paragraph>
                        <Paragraph>
                            <a
                                href="https://play.google.com/store/apps/details?id=com.leengo.app"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                LeenGo على Google Play
                            </a>
                        </Paragraph>
                        <Paragraph>
                            على أجهزة <Text strong>iPhone</Text> و<Text strong>iPad</Text> يتوفر التطبيق من خلال{' '}
                            <Text strong>App Store</Text> — ابحث عن <Text strong>LeenGo</Text> في المتجر.
                        </Paragraph>

                        <Title level={4}>هل تحتاج مساعدة؟</Title>
                        <Paragraph style={{ marginBottom: 0 }}>
                            لدعم العملاء والإجابات السريعة، راجع صفحة{' '}
                            <Link to="/support">الدعم والمساعدة</Link>.
                        </Paragraph>
                    </Card>
                </div>
            </Layout.Content>
        </Layout>
    )
}
